/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStudentAssignmentDetailsApi } from "@/api/reportingApi";
import { AssignmentInterface } from "@/ts/interfaces/MarkingPortal/AssignmentInterface";
import { mapStudentAssignmentWithDetailsApiData } from "@/utils/markingPortalDataMapper";

export const getStudentAssignmentDetailsThunk = createAsyncThunk<
    { data: AssignmentInterface; highestSubmission: any | null },
    { studentId: number; assignmentUUID: string },
    { rejectValue: string }
>(
    "reporting/assignmentDetails/fetch",
    async ({ studentId, assignmentUUID }, { rejectWithValue }) => {
        try {
            const response = await getStudentAssignmentDetailsApi(studentId, assignmentUUID);
            const d = response?.data?.data;

            const singleAssignment: AssignmentInterface =
                mapStudentAssignmentWithDetailsApiData(
                    d?.assignment,
                    d?.assignmentAssets,
                    d?.assignmentResources,
                    d?.assignmentDeliverables,
                    d?.allSubmissions,
                    false,
                    d?.exemptions,
                    true
                );

            const highestSubmission =
                singleAssignment?.assignmentDetail?.markedSubmissions?.find(
                    (a: any) => a?.isHighest === true
                ) ?? null;

            return { data: singleAssignment, highestSubmission };
        } catch (err: any) {
            return rejectWithValue(err?.response?.data?.message ?? err?.message ?? "Failed to load assignment details");
        }
    }
);
